<template>
  <!-- 'suspension-top': suspensionStyle(wgt), 'suspension-bottom': suspensionStyle(wgt) } -->
  <div
    :class="{ 'wgt-suspension': true, 'suspension-top': value.position === 'top', 'suspension-bottom': value.position === 'bottom' }"
    :style="suspensionStyle">
    <div class="wgt-suspension-content">
      <div
        v-if="showMemberBenefitPreview"
        class="member-benefit-preview"
        :class="{ 'member-benefit-preview--closeable': value.isCloseable == 'yes' }"
      >
        <div class="member-benefit-preview__content">
          <span class="member-benefit-preview__text">您有 </span>
          <span class="member-benefit-preview__highlight">5 张优惠券</span>
          <span class="member-benefit-preview__text">和</span>
          <span class="member-benefit-preview__highlight"> 1000 </span>
          <span class="member-benefit-preview__text">积分待使用</span>
        </div>
        <div class="member-benefit-preview__button">查看</div>
      </div>
      <CompHotimg :value="{data:value.defaultSetting}" v-else-if="showDefaultSettingPreview"/>
      <CompHotimg :value="{data:data}" :visible="visible" v-else-if="showCurrentPreview"/>
      <div v-if="value.isCloseable == 'yes'" class="close-icon">
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import config from './config'
import CompHotimg from '../../comps/comp_hotImg';

const HOT_ZONE_MODE = 'hotZone'
const MEMBER_BENEFIT_MODE = 'memberBenefit'

export default {
  name: 'Suspension',
  wgtName: '悬浮层',
  wgtDesc: '',
  wgtIcon: 'wgt-suspension',
  wgtType: 1,
  wgtTem: 1,//0代表微信和抖音小程序都可以配置,1代表只能配置微信
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      imgOffset: {
        width: 0,
        height: 0
      },
      refresh:false
    }
  },
  components: {
    CompHotimg
  },
  methods: {
    handleLode(e) {
      const { naturalWidth, naturalHeight } = e.target
      this.imgOffset = {
        width: naturalWidth,
        height: naturalHeight
      }
    }
  },
  computed: {
    suspensionStyle() {
      const { backgroundColor, backgroundImage, position, distance, margin, padding } = this.value
      let style = {
        backgroundColor,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        margin: `0px ${margin.paddedr}px 0px ${margin.paddedl}px`,
        width: `calc(100% - ${margin.paddedl + margin.paddedr}px)`,
        padding: `${padding.paddedt}px ${padding.paddedr}px ${padding.paddedb}px ${padding.paddedl}px`,
      }
      if (position === 'top') {
        return {
          ...style,
          top: `${distance}px`,
        }
      } else {
        return {
          ...style,
          bottom: `${distance}px`,
        }
      }
    },
    data(){
      return this.value.data[`${this.value.data.type}`]
    },
    visible() {
      return this.value.data.type=='noVip'
    },
    showMemberBenefitPreview() {
      if (this.value.visibleRange == 'all') {
        return this.value.data.type == 'vip' && ((this.data || {}).displayMode || HOT_ZONE_MODE) === MEMBER_BENEFIT_MODE
      }
      if (this.value.visibleRange == 'vip') {
        return ((this.value.defaultSetting || {}).displayMode || HOT_ZONE_MODE) === MEMBER_BENEFIT_MODE
      }
      return false
    },
    showDefaultSettingPreview() {
      if (this.value.visibleRange == 'all') return false
      if (this.value.visibleRange != 'vip') return true
      return ((this.value.defaultSetting || {}).displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE
    },
    showCurrentPreview() {
      if (this.value.visibleRange != 'all') return false
      if (this.value.data.type != 'vip') return true
      return ((this.data || {}).displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE
    }
  },

}
</script>

<style lang="scss" scoped>
.wgt-suspension {
  box-sizing: border-box;
  min-height: 20px;

  .wgt-suspension-content {
    position: relative;

    .member-benefit-preview {
      min-height: 49px;
      padding: 10px 12px;
      border-radius: 8px;
      background: #f1effb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      &__content {
        flex: 1;
        color: #666666;
        font-size: 12px;
        line-height: 20px;
        padding-right: 12px;
      }

      &__text {
        color: #666666;
      }

      &__highlight {
        color: #6974ff;
        font-weight: 600;
      }

      &__button {
        width: 36px;
        height: 22px;
        line-height: 22px;
        border-radius: 14px;
        background: linear-gradient(90deg, #8b88ff 0%, #6e76ff 100%);
        color: #fff;
        font-size: 10px;
        white-space: nowrap;
        text-align: center;
      }
    }

    .close-icon {
      position: absolute;
      // top: 5px;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      i {
        color: #000;
        font-size: 14px;
      }
    }
  }
}
</style>

